import { Component, Input, Output, EventEmitter } from '@angular/core'

import { UsersService } from '../../services/users.service'
import { User } from '../../models/user.model'

@Component({
  selector: 'ld-select-user-multiple',
  template: require('./select-user-multiple.component.html'),
  styles: [require('./select-user-multiple.component.css')]
})
export class SelectUserMultipleComponent {
  @Input('active') active: User[]
  @Input('filteredIds') filteredIds = []
  @Output('activeChange') activeChange = new EventEmitter<User[]>()

  constructor (private usersService: UsersService) {
    this.optionsLookup = this.optionsLookup.bind(this)
  }

  onChange (users: User[]) {
    this.activeChange.emit(users)
  }

  // see: https://edcarroll.github.io/ng2-semantic-ui/#/modules/select
  async optionsLookup (query, initial?) {
    const users = initial || await this.usersService.get(query, false).catch(() => [])
    
    return users
      .filter((user) => !this.filteredIds.find((filteredId) => filteredId === user.id))
      .map((user) => ({ user: user, name: `${user.firstname} ${user.lastname}` }))
  }
}



// WEBPACK FOOTER //
// ../~/angular2-template-loader!./app/components/select-user-multiple/select-user-multiple.component.ts